<template>
    <div>
        <ui-textbox 
            :disabled="disabled"
            :label="label" 
            :placeholder="placeholder"
            :help="help"
            v-model="textProxy"
        ></ui-textbox>
    </div>
</template>

<script>
    export default {
        props: {
            value: {}, 
            label: {},
            help: {},
            placeholder: {
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            textProxy: {
                get() {
                    if (this.value !== '%') {
                        return this.value;
                    }

                    return '';
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>